"use strict";'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var chunkLXX3SSRV_js = require('./chunk-LXX3SSRV.js');
var chunkFEIY7W7S_js = require('./chunk-FEIY7W7S.js');
var reactDropdownMenu = require('@radix-ui/react-dropdown-menu');
var r = require('styled-components');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var r__default = /*#__PURE__*/_interopDefaultLegacy(r);

var A={};chunkFEIY7W7S_js.a(A,{Arrow:()=>C,Content:()=>S,Description:()=>R,Item:()=>k,ItemLabel:()=>L,Label:()=>z,Portal:()=>P,RightSlot:()=>I,Root:()=>x,Separator:()=>y,Sub:()=>w,SubContent:()=>$,SubTrigger:()=>T,Trigger:()=>h});var e=r.css`
  max-width: 320px;
  box-shadow: var(--elevation-300);
  background: var(--background-level-3);
  border-radius: var(--border-radius-small);
  padding: var(--spacing-small) var(--spacing-x-small);
`,t=r.css`
  display: flex;
  gap: var(--spacing-small);
  padding: var(--spacing-small) var(--spacing-regular);
  margin-bottom: var(--spacing-x-small);
  color: var(--foreground-primary);
  font-size: var(--font-size-regular);
  user-select: none;
  text-decoration: none;
  cursor: pointer;

  ${chunkLXX3SSRV_js.b} {
    color: var(--foreground-secondary);
  }

  :focus {
    outline: var(--border-width-small) solid var(--border-link-focus);
    border-radius: var(--border-radius-small);
  }

  :hover:not(&[data-disabled]) {
    background-color: var(--background-selected);
    border-radius: var(--border-radius-small);
    outline: none;
  }

  &[data-disabled] {
    color: var(--foreground-disabled);
    ${chunkLXX3SSRV_js.b} {
      color: var(--foreground-disabled);
    }
  }
`,x=r__default["default"](reactDropdownMenu.Root).attrs(i=>({modal:!1,...i}))``,h=r__default["default"](reactDropdownMenu.Trigger)`
  align-items: center;

  &[data-state='open'] {
    background: var(--background-button-secondary-active);
    color: var(--foreground-button-secondary-hover);
    border: 4px solid var(--background-button-destructive-disabled);
  }
`,P=r__default["default"](reactDropdownMenu.Portal)``,S=r__default["default"](reactDropdownMenu.Content).attrs({sideOffset:4})`
  ${e}
`,k=r__default["default"](reactDropdownMenu.Item)`
  ${t}
`,w=r__default["default"](reactDropdownMenu.Sub)`
  padding: var(--spacing-small) var(--spacing-regular);
`,y=r__default["default"](reactDropdownMenu.Separator)`
  height: 1px;
  background-color: var(--border-default);
  margin: var(--spacing-x-small);
`,z=r__default["default"](reactDropdownMenu.Label)`
  color: var(--foreground-tertiary);
  font-size: var(--font-size-small);
  font-weight: var(--font-weight-bold);
  text-transform: uppercase;
  letter-spacing: var(--letter-spacing-spacious);
  padding: var(--spacing-small) var(--spacing-regular);
`,C=r__default["default"](reactDropdownMenu.Arrow)`
  fill: white;
`,T=r__default["default"](reactDropdownMenu.SubTrigger)`
  ${t}
`,$=r__default["default"](reactDropdownMenu.SubContent).attrs({sideOffset:4})`
  ${e}
`,I=r__default["default"].div`
  margin-left: auto;
  padding-left: var(--spacing-regular);
`,L=r__default["default"].div``,R=r__default["default"].div`
  color: var(--foreground-secondary);
  font-size: var(--font-size-small);
  line-height: var(--line-height-large);
`;

exports.a = x;
exports.b = h;
exports.c = P;
exports.d = S;
exports.e = k;
exports.f = w;
exports.g = y;
exports.h = z;
exports.i = C;
exports.j = T;
exports.k = $;
exports.l = I;
exports.m = L;
exports.n = R;
exports.o = A;
